import React, { useState } from "react";
import { toggle } from "../../../util/common";
import { WalletItemCreditCard } from "../../../store/common";
import { DialogComponent } from "../../common/DialogComponent";
import ConfirmDeleteWalletDialog from "../../Dialogs/lostWallet/ConfirmDeleteWalletDialog";
import CreditDebitCardDialog from "../../Dialogs/lostWallet/CreditDebitCardDialog";
import { countryList } from "../../../util/CommonLists";
import { useTranslation } from "react-i18next";

const CreditDebitCard: React.FunctionComponent<{ requestDataCallback(): void; walletItemCreditCards: WalletItemCreditCard[] }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [deleteWalletDialogIsVisible, setDeleteWalletDialogIsVisible] = useState(false);
    const [creditCardDialogIsVisible, setCreditCardDialogIsVisible] = useState(false);
    const [selectedCard, setSelectedCard] = useState({});
    const [cardNumber, setCardNumber]:any= useState([]);
   
    const showDeleteWalletDialog = (selectedItem: WalletItemCreditCard): any => {
        setSelectedCard(selectedItem);
        setDeleteWalletDialogIsVisible(true);
    };

    const closeDeleteWalletDialog = (): any => {
        setDeleteWalletDialogIsVisible(false);
    };

    const showCreditCardDialog = (selectedItem: WalletItemCreditCard): any => {
        setSelectedCard(selectedItem);
        setCreditCardDialogIsVisible(true);
    };

    const closeCreditCardDialog = (): any => {
        setCreditCardDialogIsVisible(false);
    };
    const toggleCardNumVisibility=(card:any)=>{
        if (cardNumber.length > 0) {
            const index = cardNumber.findIndex((element: any) =>  element.cardNumber ===card.cardNumber);
         if (index >= 0) {
            cardNumber.splice(index, 1);
            setCardNumber([...cardNumber]);
        } 
         else {
            setCardNumber([...cardNumber, card]);
         }
          } else {
            setCardNumber([...cardNumber , card]);
         }

    }
    return (
        <React.Fragment>
            {props.walletItemCreditCards &&
                props.walletItemCreditCards.map((card: WalletItemCreditCard, index) => (
                    <div className="data-row" key={"credit-card-" + index}>
                        <div className="link-item">
                            <button
                                type="button"
                                aria-expanded="false"
                                className="link-button"
                                id={"btn-credit-card-" + index}
                                onClick={() => toggle(`credit-card-${index}-details`, `btn-credit-card-${index}`)}
                            >
                                <span className="row link-item">
                                    <span className="col-xs col-no-gutter link-text">
                                        <span className="link-title">
                                            <span className="btn-toggle-status sr-only">Show</span> {card.cardName}
                                        </span>
                                        <span className="link-helper">
                                            <span className="sr-only">Item Type: </span>
                                            {card.cardCategory ? card.cardCategory.split(" ")[0].toUpperCase() : ""}
                                        </span>
                                    </span>
                                </span>
                            </button>

                            <div className="wallet-details" id={"credit-card-" + index + "-details"} style={{ display: "none" }}>
                                <h4 id={"credit-card-" + index + "-title"} className="sr-only">
                                    {card.cardHolderName}
                                </h4>
                                <div
                                    role="grid"
                                    className="data-grid row-height-xs"
                                    aria-labelledby={"credit-card-" + index + "-title"}
                                >
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-card-category"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.cardCategory")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-card-category"}>
                                                {card.cardCategory ? card.cardCategory.split(" ")[0].toUpperCase() : ""}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-cardholder-name"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.cardholderName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-cardholder-name"}>
                                                {card.cardHolderName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-card-type"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.cardType")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-card-type"}>
                                                {card.cardType}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-card-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.cardNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-card-number"}>
                                             {card &&
                                                card.cardNumber &&  cardNumber.findIndex((element: any) => element.cardNumber ===card.cardNumber) < 0 ?
                                                      `${"X".repeat(card.cardNumber.substr(0, card.cardNumber.length - 4).length)}${card.cardNumber.substr(
                                                        card.cardNumber.length - 4
                                                      )}` :card.cardNumber }  

<button
                                                type="button"
                                                className="btn-default btn-icon-only btn-no-padding"
                                                onClick={() => {
                                                   toggleCardNumVisibility(card);
                                                }}
                                                title={"Show CardNumber Text"}
                                                style={{marginLeft: '1.25rem'}}
                                            >
                                                <span className="btn-icon">
                                                    <em
                                                        className={`las ${
                                                            cardNumber.findIndex((element: any) => element.cardNumber ===card.cardNumber) < 0 ? "la-eye" : "la-eye-slash"
                                                        }`}
                                                    ></em>
                                                </span>
                                                <span className="btn-text">Show / Hide CardNumber Text</span>
                                            </button>        
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-card-name-bank"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.card-bankName")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-card-name-bank"}>
                                                {card.cardName}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-expiry-date"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.expiryDate")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-expiry-date"}>
                                                {card.expirationDate}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-pin"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.pin")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-pin"}>
                                                {card.pin}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-card-level"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.cardLevel")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-card-level"}>
                                                {card.cardLevel}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-issuing-country"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.country")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-issuing-country"}>
                                                {countryList.find((c) => c.code === card.issuingCountry)?.name}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-website"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.website")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-website"}>
                                                {card.webSite}
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-phone-number"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.serviceNumber")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-phone-number"}>
                                            {card.customerServicePhoneNumber} 
                                            </div>
                                        </div>
                                    </div>
                                    <div role="row" className="data-row condensed row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div role="gridcell" className="data-label" id={"credit-" + index + "-notes"}>
                                                {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.label.notes")}
                                            </div>
                                        </div>
                                        <div className="col-xs-11 col-sm-7 col-no-gutter">
                                            <div role="gridcell" className="data-value" aria-labelledby={"credit-" + index + "-notes"}>
                                                {card.notes}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row between-xs margin-top-l">
                                    <div className="col-xs flex-grow-null col-no-gutter"></div>
                                    <div className="col-xs flex-grow-null col-no-gutter">
                                        <ul className="list-reset list-inline">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-red-outline btn-no-border"
                                                    onClick={() => showDeleteWalletDialog(card)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.deleteButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                            <li className="margin-left-xs">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-primary-outline"
                                                    id="edit-credit-card-1"
                                                    onClick={() => showCreditCardDialog(card)}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-edit-alt"></em>
                                                    </span>
                                                    <span className="btn-text">
                                                        {tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.editDetailsButtonText")}
                                                    </span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

            {/* Delete modal*/}
            {deleteWalletDialogIsVisible && (
                <DialogComponent dialogId="dialog-delete-credit-card-wallet" title="Delete Wallet" closeDialog={closeDeleteWalletDialog}>
                    <ConfirmDeleteWalletDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeDeleteWalletDialog}
                        walletItem={selectedCard}
                        itemType="credit-card"
                    />
                </DialogComponent>
            )}

            {/* Edit modal*/}
            {creditCardDialogIsVisible && (
                <DialogComponent dialogId="dialog-edit-credit-card-wallet" title="Edit Credit Card Wallet" closeDialog={closeCreditCardDialog}>
                    <CreditDebitCardDialog
                        requestDataCallback={props.requestDataCallback}
                        closeDialog={closeCreditCardDialog}
                        walletItem={selectedCard}
                        isNew={false}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default CreditDebitCard;
